import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M482.347 17.689c-11.82-11.798-28.928-15.535-44.529-9.559L32.414 161.904c-15.83 5.998-26.182 20.227-27.034 37.127s8.024 32.07 23.15 39.624l155.227 77.602 77.602 155.227c7.233 14.465 21.423 23.194 37.406 23.194.749 0 1.492 0 2.24-.044 16.901-.874 31.085-11.219 37.062-27.033L491.884 62.24c5.932-15.617 2.262-32.687-9.559-44.529zM39.476 200.741c.088-1.535.727-5.271 5.015-6.91L427.254 48.654l-234.129 234.13-149.34-74.658c-3.965-1.988-4.391-5.462-4.309-7.385m266.712 254.805c-1.578 4.14-4.992 4.932-6.888 5.014-1.474.022-5.336-.235-7.384-4.31l-74.659-149.338 234.13-234.13-145.199 382.742z" }, null, -1)
  ])))
}
export default { render: render }